import React from 'react'
import PropTypes from 'prop-types'
import { GENDER } from 'domains/seller-inbound/constants'
import StatusBadge from 'components/atoms/status-badge'


const propTypes = {
  gender: PropTypes.string
}

const ScraperProductGenderBadge = ({ gender }) => {

  const colorMap = {
    [GENDER.FEMALE] : 'danger',
    [GENDER.MALE]   : 'primary'
  }

  const color = colorMap[gender] || 'default'

  const label = `${gender}`

  return <StatusBadge color={ color } label={ label } />
}

ScraperProductGenderBadge.propTypes = propTypes

export default ScraperProductGenderBadge